import { createFileRoute } from "@tanstack/react-router";
import { SalesSystemDiagramViewerPage } from "src/components/views/erp/common/systemDiagrams/viewer/SystemDiagramViewerPage.tsx";
import { SystemDiagramViewerApi } from "src/api/generated/systemDiagrams/viewer/systemDiagramViewerApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId")({
	staticData: {
		legacyViewKey: "salesSystemDiagramsPage",
		listGeneratedViews: async () =>
			(await SystemDiagramViewerApi.listSales()).diagrams.map((diagram) => ({
				id: diagram.systemDiagramId,
				title: diagram.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
	} = useKeptAliveGeneratedView();
	return <SalesSystemDiagramViewerPage systemDiagramId={id} />;
}
